var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.665 32.0625C16.598 32.0625 18.165 30.4955 18.165 28.5625C18.165 26.6295 16.598 25.0625 14.665 25.0625C12.732 25.0625 11.165 26.6295 11.165 28.5625C11.165 30.4955 12.732 32.0625 14.665 32.0625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.665 32.0625C30.598 32.0625 32.165 30.4955 32.165 28.5625C32.165 26.6295 30.598 25.0625 28.665 25.0625C26.732 25.0625 25.165 26.6295 25.165 28.5625C25.165 30.4955 26.732 32.0625 28.665 32.0625Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.665 32.0625C44.598 32.0625 46.165 30.4955 46.165 28.5625C46.165 26.6295 44.598 25.0625 42.665 25.0625C40.732 25.0625 39.165 26.6295 39.165 28.5625C39.165 30.4955 40.732 32.0625 42.665 32.0625Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.b8d66a87.svg";
export { ForwardRef as ReactComponent };